/* eslint-disable require-jsdoc */

export const initSelect = () => {
    const customSelectElements = document.querySelectorAll('[data-js-input-select]');
    const customSelectElementsLength = customSelectElements.length;

    let optionDiv;

    for (let i = 0; i < customSelectElementsLength; i++) {
        // Get the <select> element inside the custom select container
        const selectElement = customSelectElements[i].getElementsByTagName('select')[0];
        const selectElementLength = selectElement.length;
    
        // Create a new DIV that will act as the selected item
        const selectedDiv = document.createElement('DIV');
        const selectedDivLabel = document.createElement('DIV');
        const selectedDivValue = document.createElement('DIV');
        selectedDiv.setAttribute('class', 'select-selected');
        selectedDivLabel.setAttribute('class', 'select-selected-label');
        selectedDivValue.setAttribute('class', 'select-selected-value');
        selectedDivLabel.innerHTML = selectElement.getAttribute('label');
        selectedDiv.appendChild(selectedDivLabel);
        selectedDiv.appendChild(selectedDivValue);
        customSelectElements[i].appendChild(selectedDiv);
    
        // Create a new DIV that will contain the option list
        const optionListDiv = document.createElement('DIV');
        optionListDiv.setAttribute('class', 'select-items select-hide');
    
        for (let j = 1; j < selectElementLength; j++) {
            // Create a new DIV for each option in the original select element
            optionDiv = document.createElement('DIV');
            optionDiv.innerHTML = selectElement.options[j].innerHTML;
    
            // Add click event listener to the option div
            optionDiv.addEventListener('click', function() {
                let sameAsSelectedItems;
                const originalSelect = this.parentNode.parentNode.getElementsByTagName('select')[0];
                const selectedOption = this.parentNode.previousSibling;
                const selectedOptionValue = selectedOption.querySelector('.select-selected-value');
                selectedOption.parentNode.classList.add('chosen');
    
                for (let k = 0; k < originalSelect.length; k++) {
                    if (originalSelect.options[k].innerHTML == this.innerHTML) {
                        originalSelect.selectedIndex = k;
                        selectedOptionValue.innerHTML = this.innerHTML;
    
                        sameAsSelectedItems = this.parentNode.getElementsByClassName('same-as-selected');
                        for (let l = 0; l < sameAsSelectedItems.length; l++) {
                            sameAsSelectedItems[l].removeAttribute('class');
                        }
    
                        this.setAttribute('class', 'same-as-selected');
                        break;
                    }
                }
                selectedOption.click();
            });
    
            optionListDiv.appendChild(optionDiv);
        }
        customSelectElements[i].appendChild(optionListDiv);
    
        // Add click event listener to the selected item div
        selectedDiv.addEventListener('click', function(e) {
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle('select-hide');
            this.parentNode.classList.toggle('open');
        });
    }
}

function closeAllSelect(element) {
    // Function to close all select boxes in the document except the current one
    const elementArray = [];
    const allSelectItems = document.getElementsByClassName('select-items');
    const allSelectedItems = document.getElementsByClassName('select-selected');

    for (let i = 0; i < allSelectedItems.length; i++) {
        if (element == allSelectedItems[i]) {
            elementArray.push(i);
        } else {
            allSelectedItems[i].parentNode.classList.remove('open');
        }
    }

    for (let i = 0; i < allSelectItems.length; i++) {
        if (elementArray.indexOf(i) === -1) {
            allSelectItems[i].classList.add('select-hide');
        }
    }
}

// Close all select boxes if the user clicks anywhere outside of the select box
document.addEventListener('click', closeAllSelect);
